import React, {FC} from "react";
import {useSelector} from "react-redux";
import "./info-banner.scss";

const InfoBanner: FC = () => {
  return <div className="info-banner">{`This is the only site where you can get your bridge referral link !`}</div>;
};

export default InfoBanner;
